import { Card, CardContent, styled } from "@mui/material";

const ContainerDetails = styled('div')(({ theme }) => ({
  padding: '16px',
  marginLeft: '32px',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  marginRight: '16px',
}));

const ContentDetails = styled('div')(({ noBorder }) => ({
  display: 'flex',
  flex: 1,
  justifyContent: 'space-between',
  padding: '16px',
  borderBottom: noBorder ? 0 : 'solid 1px #d1d1d1',
}));

const ContentTextTitle = styled('div')({
  fontWeight: 'bold',
  fontFamily: 'Roboto, sans-serif',
});

const ContentTextValue = styled('div')({
  fontWeight: 300,
  fontFamily: 'Roboto, sans-serif',
});

const SiniestroTableDetail = ({ rowData }) => (
  <ContainerDetails>
    <Card>
      <CardContent>
        <ContentDetails>
          <ContentTextTitle>Modalidad de Denuncia</ContentTextTitle>
          <ContentTextValue>
            {rowData.modalidadDenuncia || "---"}
          </ContentTextValue>
        </ContentDetails>
        <ContentDetails>
          <ContentTextTitle>Prestador Inicial</ContentTextTitle>
          <ContentTextValue>
            {rowData.prestadorInicial || "---"}
          </ContentTextValue>
        </ContentDetails>
        <ContentDetails>
          <ContentTextTitle>Establecimiento</ContentTextTitle>
          <ContentTextValue>
            {rowData.establecimiento || "---"}
          </ContentTextValue>
        </ContentDetails>
      </CardContent>
    </Card>
  </ContainerDetails>
);

export default SiniestroTableDetail;
